export default "/assets/images/list-icon6.svg?51e7fabf32c5cf97cce2cb3856315690";